var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D4E7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.18555V13.75C13.75 14.0484 13.6315 14.3345 13.4205 14.5455C13.2095 14.7565 12.9234 14.875 12.625 14.875H7.375C7.07663 14.875 6.79048 14.7565 6.5795 14.5455C6.36853 14.3345 6.25 14.0484 6.25 13.75V6.25C6.25 5.95163 6.36853 5.66548 6.5795 5.4545C6.79048 5.24353 7.07663 5.125 7.375 5.125H9.68945C9.8883 5.12503 10.079 5.20402 10.2196 5.34461L13.5304 8.65539C13.671 8.79601 13.75 8.9867 13.75 9.18555Z",
    stroke: "#2685CA",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.3125V8.125C10 8.32391 10.079 8.51468 10.2197 8.65533C10.3603 8.79598 10.5511 8.875 10.75 8.875H13.5625M8.125 10.75H11.875M8.125 12.625H11.875",
    stroke: "#2685CA",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/projectIcon.cc11a5d224a2584c31c671db2eae51f7.svg";
export { ForwardRef as ReactComponent };